// @ts-nocheck
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Box,
  Switch,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../../../common/components';
import { StringUtils } from '../../../../../../common/utils';

const useStyles = makeStyles(theme => ({
  container: {
    flex: '1',
    height: '100%',
    minHeight: '500px',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
  dialog: {
    padding: '0',
    marginBottom: '0',
  },
  dialogContent: {
    display: 'flex',
    maxWidth: '1200px',
    overflow: 'hidden',
  },
  searchButton: {
    marginLeft: theme.spacing(2),
  },
  searchField: {
    flex: '1',
    paddingRight: theme.spacing(2),
    '& .MuiInputBase-input': {
      height: '100%',
    },
  },
}));

function ProductList(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const {
    products,
    productChanges,
    filterParams,
    onSelectProduct,
    onFilterChange,
    actionsDisabled,
  } = props;

  const checkForFutureChanges = (productId) => {
    return productChanges.productChanges.some(change => change.productId === productId && change.state === 'PENDING')
  };

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'asc',
    },
  ]);

  const getColumnDefs = () => [
    {
      field: 'id',
      headerName: t('product.id'),
      width: 130,
    },
    {
      field: 'title',
      headerName: t('product.productTitle'),
      width: 250,
      flex: 1,
    },
    {
      field: 'price',
      headerName: t('product.productPrice'),
      width: 165,
      valueFormatter: params => StringUtils.getFormattedSum(params.value),
    },
    {
      field: 'discountDays',
      headerName: t('product.productFreePeriod'),
      width: 175,
      valueFormatter: params => StringUtils.getFormattedDays(params.value),
    },
    {
      field: 'commitmentDays',
      headerName: t('product.productCommitmentDays'),
      width: 185,
      valueFormatter: params => StringUtils.getFormattedDays(params.value),
    },
    {
      field: 'discountEligibilityIntervalDays',
      headerName: t('product.productQuarantineDays'),
      width: 175,
      valueFormatter: params => StringUtils.getFormattedDays(params.value),
    },
    {
      field: 'suspendFree',
      headerName: t('product.productSuspendFree'),
      width: 150,
      sortable: false,
      renderCell: params => <Checkbox checked={params.value} className={classes.checkbox} />,
    },
    {
      field: 'futureChangesExist',
      headerName: t('product.futureChangesExist'),
      headerAlign: 'left',
      width: 175,
      type: 'boolean',
      sortable: false,
      renderCell: params => <Checkbox checked={checkForFutureChanges(params.row.id)} className={classes.checkbox} />,
    },
  ];

  const getRowData = () => products;

  const handleFilterChange = event => {
    const filter = {
      ...filterParams,
    };

    if (event.target.id === 'ProductList-onlyBuyable') {
      filter.onlyBuyable = event.target.checked;
    } else if (event.target.id === 'ProductList-channels') {
      filter.channels = event.target.checked;
    }

    onFilterChange(filter);
  };

  const renderToolbar = () => (
    <GridToolbarContainer>
      <FormControlLabel
        className={classes.switch}
        control={
          <Switch
            id="ProductList-onlyBuyable"
            color="primary"
            checked={filterParams.onlyBuyable}
            onChange={handleFilterChange}
            disabled={actionsDisabled}
          />
        }
        label={t('product.productsOnlyBuyable')}
      />
      <FormControlLabel
        className={classes.switch}
        control={
          <Switch
            id="ProductList-channels"
            color="primary"
            checked={filterParams.channels}
            onChange={handleFilterChange}
            disabled={actionsDisabled}
          />
        }
        label={t('product.productsChannels')}
      />
    </GridToolbarContainer>
  );

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('common.empty')} />
    </GridOverlay>
  );

  return (
    <Box id="ProductList-container" className={classes.container}>
      <DataTable
        id="ProductList-table"
        components={{
          Toolbar: renderToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        rowCount={products.length}
        onRowClick={onSelectProduct}
        sortModel={sortModel}
        sortingOrder={['asc', 'desc']}
        sortingMode="client"
        paginationMode="client"
        pageSize={20}
        pagination
      />
    </Box>
  );
}

ProductList.defaultProps = {
  productChanges: {
    productChanges: [],
    pageCount: 1,
    pageEntries: 0,
    totalCount: 0
  },
};

ProductList.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  productChanges: PropTypes.shape({
    productChanges: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageCount: PropTypes.number,
    totalCount: PropTypes.number,
    pageEntries: PropTypes.number,
  }).isRequired,
  filterParams: PropTypes.shape({
    onlyBuyable: PropTypes.bool,
    channels: PropTypes.bool,
  }).isRequired,
  onSelectProduct: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default ProductList;
